import {Component, Input, ChangeDetectionStrategy} from "@angular/core";
import {Exemption_TypeVessel, FormVessel, FormBarge, FormShip} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-visit-exemptions-vessel',
    templateUrl: './exemptions_vessel.component.html',
    styleUrls: ['./exemptions_vessel.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionsVesselComponent {

  @Input() vesselType: string;
  @Input() vessels: FormVessel[];
  @Input() maxNumberOfVessels: number;
  @Input() vesselPrefixes: string[];
  @Input() shipLabelTooltip: string;

  vesselTypes: Exemption_TypeVessel[] = [null, Exemption_TypeVessel.IMO, Exemption_TypeVessel.ENI];

  vesselTypesFormatter = (vesselType: Exemption_TypeVessel) => {
    switch (vesselType) {
      case "ENI":
        return 'ENI';
      case "IMO":
        return 'IMO';
    }
  };

  addVessel() {

    if (this.maxNumberOfVessels === this.vessels?.length) {
      return;
    }

    if (this.vesselType === 'ENI') {
      let barge: FormBarge = {
        vesselType: 'ENI'
      };
      this.vessels.push(barge);
    } else if (this.vesselType === 'IMO') {
      let ship: FormShip = {
        vesselType: 'IMO'
      };
      this.vessels.push(ship);
    }
  }

  removeVessel(vesselIndex : number) {
    this.vessels.splice(vesselIndex, 1);
  }
}
